import { styled } from 'theme'

export const StyledPriorityList = styled.div`
  background-color: white;
`
